import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss'],
})
export class ErrorModalComponent {
  @Input() noButtons = false;
  @Input() title: string = 'Something went wrong';
  @Input() message: string = 'System error, please try again in a few minutes';

  @Output() closePressed: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private dialogRef: MatDialogRef<ErrorModalComponent>
  ) {}

  close() {
    this.closePressed.emit(true);
    this.dialogRef.close();
  }
}
